import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import PopularCard from "../../components/Cards/PopularCard";
import { collection, getDocs, query, where } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import ClientForm from "../../components/ClientForm/ClientForm";
import { Helmet } from "react-helmet-async";

const StateWiseTours = () => {
    const { stateName } = useParams();
    const [tours, setTours] = useState([]);
    const [loading, setLoading] = useState(true);

    const getTours = async () => {
        try {
            if (!stateName) return;

            const q = query(collection(fireDB, "tours"), where("state", "==", stateName));
            const snapshot = await getDocs(q);
            const data = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));

            setTours(data);
        } catch (error) {
            console.error("Error fetching state-wise tours:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getTours();
        document.title = `${stateName} Tours`;
        window.scrollTo(0, 0);
    }, [stateName]);
    // Dynamic meta description
    const metaDescription = tours.length
        ? `Explore ${tours.length} amazing ${stateName} tour packages with Shivay Tours. Book your dream trip today!`
        : `Discover the best tour packages in ${stateName} with Shivay Tours. Plan your next adventure now!`;

    // JSON-LD structured data for tours
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": `${stateName} Tour Packages`,
        "itemListElement": tours.map((tour, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "url": `https://www.shivaytourandtravells.com/tour-details/${tour.id}`,
            "name": tour.title,
            "image": tour.imageUrl || tour.image,
            "description": tour.description || ""
        }))
    };

    return (
        <>
            <Helmet>
                <title>{stateName} Tours | Shivay Tour & Travels</title>
                <meta name="description" content={metaDescription} />
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
                />
            </Helmet>

            <Breadcrumbs title={`${stateName} Tours`} pagename={stateName} />

            <section className="py-5 tour_list">
                <Container>
                    <h2 className="text-center fw-bold text-primary mb-4">
                        {stateName} Tour Packages
                    </h2>
                    <Row>
                        {loading ? (
                            <p className="text-center">Loading tours...</p>
                        ) : tours.length > 0 ? (
                            tours.map((val) => (
                                <Col key={val.id} xl={3} md={3} sm={6} xs={6} className="mb-4">
                                    <PopularCard val={val} />
                                </Col>
                            ))
                        ) : (
                            <Col>
                                <p className="text-center text-muted">
                                    No tours found for {stateName}.
                                </p>
                            </Col>
                        )}
                    </Row>
                </Container>
            </section>

            <ClientForm />
        </>
    );
};

export default StateWiseTours;
